import {axiosInstance, baseAxios} from 'config/axios';

export const login = async (params) => {
  const {data} = await axiosInstance.post('/public/login', params);
  return data;
};

export const getTenantInfo = async (code) => {
  const {data} = await axiosInstance.post('/tenant/tenant-info', {tenant_code: code});
  return data;
};

export const checkAccount = async (subDomain) => {
  // const {data} = await baseAxios.get(`/tenant/tenant/${subDomain}?app_type=${checkPosX() ? 'sell' : 'crm'}`);
  const {data} = await baseAxios.get(`/tenant/tenant/${subDomain}?app_type=gym`);
  return data;
};

